import classNames from 'classnames';
import { Check } from 'lib/components/misc/icons';
import { forwardRef, HTMLProps, Ref } from 'react';

import FieldErrorMessage from './FieldErrorMessage';

type CheckboxProps = Omit<HTMLProps<HTMLInputElement>, 'label'> & {
  name: string;
  label?: React.ReactNode;
  fieldError?: string;
};

const Checkbox = (
  { name, label, id, className, disabled, fieldError, ...inputProps }: CheckboxProps,
  ref: Ref<HTMLInputElement>
) => {
  const inputId = id || `input-${name}`;

  return (
    <div className={classNames('mt-8', className)}>
      <div className="flex items-start gap-x-3">
        <div className="relative mt-0.5 inline-block leading-none">
          <input
            {...inputProps}
            ref={ref}
            id={inputId}
            name={name}
            type="checkbox"
            className="peer h-6 w-6 cursor-pointer appearance-none rounded-lg border-2 border-gray-300 transition-colors checked:border-gray-900 checked:bg-gray-900 focus-visible:outline-none disabled:cursor-default"
            disabled={disabled}
            aria-invalid={!!fieldError}
          />
          <Check className="pointer-events-none absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 text-xl text-white opacity-0 transition-opacity peer-checked:opacity-100" />
        </div>
        {label && (
          <label className="cursor-pointer text-lg" htmlFor={inputId}>
            {label}
          </label>
        )}
      </div>
      {fieldError && <FieldErrorMessage className="!ml-9" message={fieldError} />}
    </div>
  );
};

export default forwardRef(Checkbox);
